import styled from 'styled-components';

export const CompactSignInWrapper = styled.div(({ theme }) => ({
  alignSelf: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  paddingLeft: theme.spacing.xlarge,
  paddingRight: theme.spacing.xlarge,
}));

export const LogInButtonWrapper = styled.div({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '20px',
  marginBottom: '20px',
});
